export default __webpack_public_path__ + "static/media/kubernetesIcon.8582fe52.svg";